import React from "react";

export const ThickChevronLeftIcon = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M12.7906 14.7698C13.0777 14.4713 13.0684 13.9965 12.7698 13.7094L8.83208 10L12.7698 6.29062C13.0684 6.00353 13.0777 5.52875 12.7906 5.23017C12.5035 4.93159 12.0287 4.92228 11.7302 5.20937L7.23017 9.45937C7.08311 9.60078 7 9.79599 7 10C7 10.204 7.08311 10.3992 7.23017 10.5406L11.7302 14.7906C12.0287 15.0777 12.5035 15.0684 12.7906 14.7698Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
